export const bonusReferrals = {
    CF : 100,
    PT : 200,
    PM : 100,
    EM : 100
}